<int-integrators-details
        [integrationName]="integrationName"
        [integrationType]="integrationType"
        [creating]="creating"
        [user]="user"
        [invites]="invites"></int-integrators-details>
<div mat-dialog-content>
  <!-- REPORTING -->

  <div *ngIf="creating" class="int-text-container">
    {{description}}
  </div>

  <!-- prettier-ignore -->
  <div *ngIf="creating" fxLayout="column" fxLayoutAlign="start center">
      <div (click)="onClick($event)" *ngIf="!loading && !(viewOptions.length)" class="google-btn">
        <div class="google-icon-wrapper">
          <img class="google-icon-svg" src="../../assets/image/google-signin-btn.svg" />
        </div>
        <p class="btn-text"><b>Sign in with Google</b></p>
      </div>

      <div *ngIf="!loading && viewOptions.length" class="half-width mt-1">
        <mat-form-field class="full-width">
          <mat-label>View</mat-label>
          <mat-select [(ngModel)]="selectedView">
            <mat-optgroup *ngFor="let group of viewOptions" [label]="group.name">
              <mat-option *ngFor="let view of group.views" [value]="view">
                {{view.name}}
              </mat-option>
            </mat-optgroup>
          </mat-select>
        </mat-form-field>
      </div>

    </div>

  <div *ngIf="isAdmin && invites.length > 0">
    <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
  </div>

  <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center" class="int-add-container">
    <button mat-stroked-button color="primary" (click)="addAnother($event)">
      <mat-icon>add</mat-icon>
      <span class="center-text">ADD ANOTHER ACCOUNT</span>
    </button>
  </div>

  <div *ngIf="!noAccounts && !creating">
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="!showAccounts">
      <mat-icon>expand_more</mat-icon>
      <span>SHOW CONNECTED ACCOUNTS</span>
    </button>
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="showAccounts">
      <mat-icon>expand_less</mat-icon>
      <span>HIDE CONNECTED ACCOUNTS</span>
    </button>
  </div>

  <div *ngIf="!creating" [hidden]="!showAccounts">
    <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Accounts</h4>
    <div *ngFor="let int of existingIntegrations">Account Name: {{ int.friendlyName }}</div>
  </div>

  <mat-error *ngIf="creating && errorMsg">{{ errorMsg }}</mat-error>
</div>

<div fxLayout="row" fxLayoutAlign="end end">
  <button mat-button mat-dialog-close>CANCEL</button>
  <button
    *ngIf="creating && viewOptions && viewOptions.length"
    mat-raised-button
    [disabled]="!selectedView"
    (click)="selectView($event)"
    color="primary"
  >
    SELECT VIEW
  </button>
</div>
